import { createIcon } from '../icons/utils';

/**
 * Disconnected-device glyph: a white circle with a red crossed-out connectivity
 * symbol and a soft drop shadow. Its colors are baked into the SVG (every shape
 * carries an explicit `fill`/`stroke`), so it renders the same regardless of the
 * priority `className` the lane passes — a disconnected device is always shown
 * in the destructive red, not priority-coloured.
 */
export const DisconnectedDeviceIcon = createIcon(
  ({ ref, className, innerClassName, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g filter="url(#filter0_d_12932_9004)">
        <mask id="path-1-inside-1_12932_9004" fill="white">
          <path d="M17 30C17 22.8203 22.8203 17 30 17C37.1797 17 43 22.8203 43 30C43 37.1797 37.1797 43 30 43C22.8203 43 17 37.1797 17 30Z" />
        </mask>
        <path
          d="M17 30C17 22.8203 22.8203 17 30 17C37.1797 17 43 22.8203 43 30C43 37.1797 37.1797 43 30 43C22.8203 43 17 37.1797 17 30Z"
          className={innerClassName}
          shapeRendering="crispEdges"
        />
        <path
          className={innerClassName}
          d="M17 30M43 30M43 30M17 30M30 17M43 30M30 43M17 30M30 43V41.8C23.483 41.8 18.2 36.517 18.2 30H17H15.8C15.8 37.8424 22.1576 44.2 30 44.2V43ZM43 30H41.8C41.8 36.517 36.517 41.8 30 41.8V43V44.2C37.8424 44.2 44.2 37.8424 44.2 30H43ZM30 17V18.2C36.517 18.2 41.8 23.483 41.8 30H43H44.2C44.2 22.1576 37.8424 15.8 30 15.8V17ZM30 17V15.8C22.1576 15.8 15.8 22.1576 15.8 30H17H18.2C18.2 23.483 23.483 18.2 30 18.2V17Z"
          fill="#EF4444"
          mask="url(#path-1-inside-1_12932_9004)"
        />
        <path
          d="M32.7596 28.3333C33.8999 28.6886 34.9683 29.2659 35.8997 30.0417M38.8163 27.0833C36.3809 24.9366 33.246 23.7522 29.9996 23.7522C29.4954 23.7522 28.9939 23.7808 28.4974 23.8371M27.1078 33.0084C27.9538 32.4073 28.9659 32.0844 30.0037 32.0844C31.0414 32.0844 32.0535 32.4073 32.8995 33.0084M29.9997 36.25H30.008M20.9941 27.2506C22.1055 26.2322 23.39 25.3998 24.7984 24.8025M23.943 30.2025C25.1075 29.1767 26.5344 28.4418 28.1102 28.1116M33.0816 33.1459C32.2324 32.4802 31.1623 32.0833 29.9996 32.0833C28.8193 32.0833 27.7344 32.4923 26.8792 33.1763M22.4997 22.5L37.4997 37.5"
          stroke="#EF4444"
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_12932_9004"
          x="0"
          y="0"
          width="66"
          height="66"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="3" dy="3" />
          <feGaussianBlur stdDeviation="10" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12932_9004"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12932_9004"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  {
    displayName: 'DisconnectedDeviceIcon',
    defaultSize: 66,
    classNameBase: '',
  },
);
